module.exports = __webpack_public_path__ + "media/images/countrysquared/va-139b458abee3a73c3590cb34b3f8bc0b.svg";